import { render, staticRenderFns } from "./HoldOrder.vue?vue&type=template&id=1d03b807&scoped=true"
import script from "./HoldOrder.vue?vue&type=script&lang=js"
export * from "./HoldOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d03b807",
  null
  
)

export default component.exports